import { isArray, remove, find } from 'lodash';

import {
  SET_COUNSELOR_STUDENT_ID,
  SET_COUNSELOR_STUDENT_SCHEDULE,
  SET_COUNSELOR_RETRIEVING_STUDENT_DATA,
  GRAD_PLANS_POPULATE,
  STUDENT_GRAD_PLAN_UPDATE,
  GRAD_PLANS_SET_LOADING,
  CAREER_PATHWAYS_POPULATE,
  STUDENT_CAREER_PATHWAY_UPDATE,
  CAREER_PATHWAYS_SET_LOADING,
  EXCEPTION_NOTE_SET,
  OVERRIDE_SUBMIT,
  UPDATE_PLAN_STATUS,
  SET_PLAN_ACTIVITY,
  SET_APPROVAL_STATUS,
  REMOVE_COURSE_OPTIMISTIC,
  ADD_COURSE_OPTIMISTIC,
  SET_ACTIVE_TAB_SIDEBAR,
} from 'constants/counselor';

import parseGetPlanActivitiesSuccess from 'utils/CoursePlanner/activityParser';
import parseGetApprovalStatusSuccess from 'utils/CoursePlanner/approvalStatusParser';

// eslint-disable-next-line complexity
export default function counselor(
  state = {
    studentId: undefined,
    studentSchedule: null,
    isRetrievingStudentData: false,
    selectedGradPlan: '',
    availableGradPlans: [],
    isGradPlansLoading: false,
    selectedCareerPathway: '',
    availableCareerPathways: [],
    isCareerPathwaysLoading: false,
    planActivity: [],
    approvalStatus: {},
    activeTabSideBar: 0,
  },
  action,
) {
  switch (action.type) {
    case SET_COUNSELOR_STUDENT_ID: {
      const { studentId } = action;
      return {
        ...state,
        studentId,
      };
    }

    case SET_COUNSELOR_STUDENT_SCHEDULE: {
      const { studentId, studentSchedule } = action;
      const { studentId: currentStudentId } = state;

      if (currentStudentId !== studentId) {
        return state;
      }

      return {
        ...state,
        studentSchedule,
      };
    }

    case SET_ACTIVE_TAB_SIDEBAR: {
      return {
        ...state,
        activeTabSideBar: 1 - state.activeTabSideBar,
      };
    }

    case SET_COUNSELOR_RETRIEVING_STUDENT_DATA: {
      return {
        ...state,
        isRetrievingStudentData: action.mode,
      };
    }

    case GRAD_PLANS_POPULATE: {
      const { availableGradPlans } = action;
      if (!availableGradPlans || !isArray(availableGradPlans)) {
        return state;
      }
      return {
        ...state,
        availableGradPlans: action.availableGradPlans,
      };
    }
    case STUDENT_GRAD_PLAN_UPDATE:
      return {
        ...state,
        selectedGradPlan: action.selectedGradPlan,
      };
    case GRAD_PLANS_SET_LOADING:
      return {
        ...state,
        isGradPlansLoading: action.isGradPlansLoading,
      };

    case CAREER_PATHWAYS_POPULATE: {
      const { availableCareerPathways } = action;
      if (!availableCareerPathways || !isArray(availableCareerPathways)) {
        return state;
      }
      return {
        ...state,
        availableCareerPathways: action.availableCareerPathways,
      };
    }
    case STUDENT_CAREER_PATHWAY_UPDATE:
      remove(
        state.studentSchedule.pathwayRequirements,
        pathway => pathway.id === action.pathwayIdToDelete,
      );
      state.studentSchedule.pathwayRequirements.push(
        find(state.availableCareerPathways, { id: action.pathwayIdToAdd }),
      );
      return {
        ...state,
      };
    case CAREER_PATHWAYS_SET_LOADING:
      return {
        ...state,
        isCareerPathwaysLoading: action.isCareerPathwaysLoading,
      };

    case REMOVE_COURSE_OPTIMISTIC: {
      const {
        studentSchedule: { selectedCourses },
      } = state;
      const courseIdx = selectedCourses.findIndex(
        ({ id }) => id === action.courseId,
      );
      return {
        ...state,
        studentSchedule: {
          ...state.studentSchedule,
          selectedCourses: [
            ...state.studentSchedule.selectedCourses.slice(0, courseIdx),
            ...state.studentSchedule.selectedCourses.slice(courseIdx + 1),
          ],
        },
      };
    }

    case ADD_COURSE_OPTIMISTIC: {
      return {
        ...state,
        studentSchedule: {
          ...state.studentSchedule,
          selectedCourses: [
            ...state.studentSchedule.selectedCourses,
            action.course,
          ],
        },
      };
    }

    case EXCEPTION_NOTE_SET:
      Object.assign(
        state.studentSchedule.subjectRequirements[
          action.newExceptionNote.subjectRequirementIdx
        ].exceptions[action.newExceptionNote.exceptionIdx],
        { note: action.newExceptionNote.note },
      );
      return {
        ...state,
      };
    case OVERRIDE_SUBMIT:
      Object.assign(state.studentSchedule, {
        subjectRequirements: action.subjectRequirements,
      });
      return {
        ...state,
      };
    case UPDATE_PLAN_STATUS:
      Object.assign(state.studentSchedule, { status: action.status });
      return {
        ...state,
      };
    case SET_PLAN_ACTIVITY:
      return {
        ...state,
        planActivity: parseGetPlanActivitiesSuccess(action.planActivity, state)
          .planActivity,
      };
    case SET_APPROVAL_STATUS:
      return {
        ...state,
        approvalStatus: parseGetApprovalStatusSuccess(
          action.approvalStatus,
          state,
        ).approvalStatus,
      };
    default:
      return state;
  }
}
